module.exports = __webpack_public_path__ + "img/tab-2.c1e21f3e.svg";